import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import useCanAccess from "../../hooks/useCanAccess";
import { getPageKeyFromPathname } from "../../types/Pages";

interface ProtectedLayoutProps {
    children: React.ReactNode;
}

const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ children }) => {
    const location = useLocation();
    const { isAuthenticated } = useAuth();
    const { canAccessPage } = useCanAccess();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    const pageKey = getPageKeyFromPathname(location.pathname);
    if (pageKey && !canAccessPage(pageKey)) {
        if (canAccessPage('DASHBOARD')) {
            return <Navigate to="/" replace />;
        }

        return <Navigate to="/search" />;
    }

    return <>{children}</>;
};

export default ProtectedLayout;
